import SiteLookupComponent from './site-lookup.component';
import SiteLookupRowComponent from './site-lookup-row/site-lookup-row.component';
import SiteLookupService from './site-lookup.service';

const siteLookup = angular
    .module('FacilityData.SiteLookup', [])
    .component('siteLookup', SiteLookupComponent)
    .component('siteLookupRow', SiteLookupRowComponent)
    .service('SiteLookupService', SiteLookupService)
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider.state('app.site-lookup', {
            url:'/site-lookup/',
            component: 'siteLookup',
            resolve: {
                siteList: (SiteLookupService) =>  SiteLookupService.fetchSites(),
            }
        });
    })
    .name;

export default siteLookup;



// WEBPACK FOOTER //
// ./app/components/site-lookup/site-lookup.js